var React = require('react');

function UltimateSection (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("linearGradient",{"id":"a","x1":"484.89","y1":"734.36","x2":"1841.94","y2":"-622.7","gradientTransform":"matrix(1, 0, 0, -1, 0, 224.22)","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"offset":"0.01","stopColor":"#ff6c5f","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#fea600","key":1})])),React.createElement("title",{"key":1},"ultimate-section"),React.createElement("path",{"d":"M0,0V353.79c200.37-22,908.67,118.34,1171.93,118.4,307.19.07,1082.74-155.39,1171.92-127.18V0H0Z","style":{"fill":"url(#a)"},"key":2})]);
}

UltimateSection.defaultProps = {"viewBox":"0 0 2343.85 472.19","preserveAspectRatio":"none"};

module.exports = UltimateSection;

UltimateSection.default = UltimateSection;
